import { Spinner, SpinnerProps } from '@fluentui/react-components';
import React from 'react';
import { useGetStorefrontQuery } from '../../Api/Api';
import { parseGlobalStyleConfig } from '../Helpers/globalStyleConfig';

interface IFullPageSpinnerProps {
    message?: string;
}

const FullPageSpinner: React.FC<IFullPageSpinnerProps> = (props) => {
    // Honor the storefront-wide spinner size preset (styleConfig.spinner.size); color/label are
    // applied globally via the scoped <style> injected in Layout. Default stays 'huge'.
    const sfSettings = useGetStorefrontQuery();
    const size = (parseGlobalStyleConfig(sfSettings.data?.styleConfig).spinner?.size as SpinnerProps['size']) ?? 'huge';
    return (
        <div style={{display: 'flex', alignItems: 'center', width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, justifyContent: 'center', overflow: 'hidden' }}>
            <Spinner label={<span className='spinner-label'>{props.message}</span>} size={size} labelPosition='below' />
        </div>
    );
}

export default FullPageSpinner;